import Feature from 'Services/Feature';

window.ExternalTicket = {

	addExternalTicket: function(){
		var options = {
			title	: Loc.g('Créer un nouveau ticket de support'),
			width	: 500,
			buttons	: [
				{
					text : Loc.g("Annuler"),
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Enregistrer"),
					click : function(){
						$("#externalTicketForm").submit();
					}
				}
			],
			callback	: function(){ExternalTicket.prepareExternalTicketForm();}
		};

		MyWindow.load("support_externalTicket", {action:"externalTicketForm"}, options);
	},

	prepareExternalTicketForm: function(){

		var formId	= "externalTicketForm";
		var options = {
			success	: function(data){
				var formIsOk = MyForm.processJson(data, "externalTicketForm");

				if (formIsOk){
					MyWindow.alert(Loc.g('Votre demande a bien été enregistrée.'), {type:'confirm', close:function(){
						Utils.relocate("?_f=support_externalTicket&tid="+data.tid);
					}});
				}
			},
			data : {
				action: 'recordExternalTicketForm'
			},
			dataType:"json"
		};


		MyForm.prepare(formId, "support_externalTicket", options, true);
		MyFacture.initEvent();

	},

	initOverview : function(){

		$("div.hiddenQuote").before("<br/><span onClick='Ticket.showQuote($(this));' class='moreDislayQuote'>" + Loc.g('Plier/Déplier') + " ...</span>");
		$("div.hiddenQuote").after("<br/>");

		var formId = "etoReplyForm";
		var options = {
			data	:{
				action: 'addThirdReply'
			},
			success	: function(data){

				var formIsOk = MyForm.processJson(data, "etoReplyForm");
				if (formIsOk){
					MyWindow.alert(Loc.g('Votre réponse a bien été enregistrée.'), {type:'confirm', close:function(){Utils.reload();}});
				}
			},
			dataType:"json"
		};

		MyForm.prepare(formId, "support_externalTicket", options, true);
		MyTabs.initHorizontal('ticketOverview');
	}
};

window.TicketGroup = {

	prepareFilterForm: function(){
        var options = {
			success:function(data){
				TicketGroup.processFilterForm(data);
			},
			dataType:"json"
		};
        MyForm.prepare("ticketsGroupsFilterForm", "support_groups&action=updateListing", options);
    },

	processFilterForm: function(data){
		Listing.refresh("ticketsGroupsListing", data, data.ticketsGroups_metadatas);
	}
};

window.Ticket = {

	timerAutosave	: "",
	contentReply	: "",

	addAttachement: function(data) {

		$('#conv_attachments').tokenInput("add", {id : data.file_infos.file_id , name : data.file_infos.file_fullname});

	},

	prepareFilterForm: function(action){

		action = action == undefined ? "support_tickets" : action;

        var options = {
			data	: {
				action : 'updateListing'
			},
			success	:function(data){
				Ticket.processFilterForm(data);
			},
			dataType:"json"
		};

        MyForm.prepare("ticketsFilterForm", action, options);
    },

	processFilterForm: function(data){
		Listing.refresh("ticketsListing", data, data.tickets_metadatas);
		Listing.prepareQtipListing("ticketsListing");
	},

	buildPagenum: function(pagenum, nbpage)	{

	},

	updateAssignFilter : function(listingName, inputName, value){

		$('#'+listingName+'_filter_'+inputName).val(value);
		$('#'+listingName+'_searchEngine .filterAssign').removeClass("btn-primary");
		$('#'+listingName+'_searchEngine .filterAssign:not(.btn-default)').addClass("btn-default");
		$('#'+listingName+'_searchEngine #assign'+value).addClass("btn-primary");
		Listing.update(listingName, true);

	},

	add : function(thirdid, linkDoc, docId, peopleId, nameContact, emailContact){

		thirdid		= thirdid == undefined ? '' : thirdid;
		peopleId	= peopleId == undefined ? '' : peopleId;
		linkDoc		= linkDoc == undefined ? false : linkDoc;

		var formId	= "addTicketForm";

		var options = {
			dialogClass	: "white",
			title		: Loc.g('Créer un ticket'),
			buttons		:
				[
                    {
						text : Loc.g("Annuler"),
						click : function(){
							$(this).dialog("close");
						}
					},
                    {
						text : Loc.g("Enregistrer"),
						click : function(){
							$("#"+formId).submit();
						}
					}
				],
			width		: 1200,
			callback	: function(){

				var options = {
					success		: function(data){
						var formIsOk = MyForm.processJson(data, formId);
					},
					customErrorHandler: function (error) {
						Push.error(Loc.g('Une erreur est survenue lors de la création du ticket'), false);
					},
					dataType	:"json",
					data		: {
						action	: "recordTicket",
						linkDoc : linkDoc,
						docId	: docId
					}
				};

				TokenInput.autoContact($('#ticket_thirdcontactid'), 'thirdContact', '', 1,
					function(item){
						if($('#ticket_requesterEmail').val() == '' && item.email !== undefined){
							$('#ticket_requesterEmail').val(item.email);
						}
						if(item.thirdid !== undefined && item.thirdname !== undefined){
							$("#ticket_thirdid").tokenInput('add', {id : item.thirdid, name: item.thirdname});
							$("#ticket_thirdcontactid").tokenInput('more', 'thirdid_'+item.thirdid);
						}
					},
					function(item){
						if($('#ticket_requesterEmail').val() == item.email){
							$('#ticket_requesterEmail').val('');
						}
					}
				);
				if(thirdid !== ''){
					$("#ticket_thirdcontactid").tokenInput('more', 'thirdid_'+thirdid);
				}
				if(peopleId !== ''){
					$("#ticket_thirdcontactid").tokenInput('add', {id : peopleId, name: nameContact});
                                        if(emailContact !== ""){
                                            $('#ticket_requesterEmail').val(emailContact);
                                        }
				}

				$('select[name=ticket_source]').trigger('change');


				$(".redactor_redactor.redactor_editor").css("max-height", 145);

				MyForm.prepare(formId, "support_ticket", options, true);
				MyFacture.customForm("#addTicketForm");
				Qtip.init();
			}
		};

		MyWindow.load("support_ticket", {action : "addTicketForm", thirdid : thirdid}, options);
	},

	changeLinkedThird : function( id, ident) {

		var formId = "changeThirdTicketForm";
		var options = {
			title		: Loc.g('Changer le client lié au ticket') + " #" + ident,
			buttons		:
				[
					{
						text	: Loc.g("Annuler"),
						click	: function () {
							$(this).dialog("close");
						}
					},
                    {
                        text	: Loc.g("Enregistrer"),
                        click	: function () {
                            $("#"+formId).submit();
                        }
                    }
                ],
			width		: 600,
			callback	: function () {
				TokenInput.autoContact($('#ticket_contact'), 'thirdContact', '', 1,
					function(item){

						if($('#ticket_requesterEmail').val() === '' && item.name !== undefined){

							$('#ticket_requesterEmail').val(item.email);
							MyFacture.customForm('#changeThirdTicketForm');

						}else if($('#ticket_requesterEmail').val() === '' && item.name === undefined){

							$('#ticket_requesterEmail').val(item.email);

						}else if($('#ticket_requesterEmail').val() !== '' && item.email === ''){

							$('#changeThirdTicketForm').show();
							MyFacture.customForm('#changeThirdTicketForm');

						}

						if(item.thirdid !== undefined && item.thirdname !== undefined){

							$("#ticket_thirdid").tokenInput('add', {id : item.thirdid, name: item.thirdname});
							$("#ticket_contact").tokenInput('more', 'thirdid_'+item.thirdid);

						}

					}
				);

				var options = {
					success		: function ( data) {
						var formIsOk = MyForm.processJson( data, formId);
						if(formIsOk){
							Utils.reload();
						}
					},
					dataType	: "json",
					data		: {
						action		: "changeThirdTicket",
						ticketId	: id,
						ticketIdent	: ident
					}
				};

				MyForm.prepare(formId, "support_ticket", options, true);
				MyFacture.customForm();

				var ticket_thirdid = $("#ticket_thirdid").val();
				if(ticket_thirdid !== '') {
					$("#ticket_contact").tokenInput('more', 'thirdid_' + ticket_thirdid);
				}
			}
		};

		MyWindow.load("support_ticket", {action:"modifyTicketForm", ticketid: id}, options);
	},

	removeLink: function(id) {

		var options = {
			type		: 'warning',
			buttons		: [
				{
					text	: Loc.g("Non"),
					click	: function() {
						$(this).dialog("close");
					}
				},
				{
					text	: Loc.g("Oui"),
					click	: function() {
						Ticket.removeLinkConfirm(id);
					}
				}
			]
		};

		MyWindow.alert(Loc.g("Voulez-vous vraiment supprimer le lien client sur ce ticket ?"), options);
	},

	removeLinkConfirm: function( id) {
		var options = {
			action		: 'removeLink',
			ticketId	: id
		};

		var callback = function () {
			Utils.reload();
		};

		MyFacture.post('support_ticket', options, callback, 'json');
	},

	addNote : function(ticketid){

		if(typeof(this.timerAutosave) != "") {
			clearInterval(this.timerAutosave);
		}

		if($("#ticketInfos .summary div.note").hasClass("active")) {
			$("#ticketInfos .summary div").removeClass("active");
			$("#ticketActions").show();
			$("#formContainer").html("");
		}
		else {
			$('.summaryBtn.note').append('<i class="fa fa-circle-o-notch fa-spin fa-gray" style="position:absolute;top:8px;right:5px;"></i>');
			$("#ticketInfos .summary div").removeClass("active");
			$("#ticketInfos .summary div.note").addClass("active");
			MyFacture.post('support_ticket', {
				action : "conversationForm",
				ticketid : ticketid,
				type : 'note'
			}, function(data){Ticket.prepareNoteForm(data);}, 'json');
		}
	},

	addReply : function(ticketid){

		if(typeof(this.timerAutosave) != "") {
			clearInterval(this.timerAutosave);
		}

		if($("#ticketInfos .summary div.mail").hasClass("active")) {
			$("#ticketInfos .summary div").removeClass("active");
			$("#ticketActions").show();
			$("#formContainer").html("");
		}else {
			$('.summaryBtn.mail').append('<i class="fa fa-circle-o-notch fa-spin fa-gray" style="position:absolute;top:8px;right:5px;"></i>');
			$("#ticketInfos .summary div").removeClass("active");
			$("#ticketInfos .summary div.mail").addClass("active");

			MyFacture.post('support_ticket', {action : "conversationForm", ticketid : ticketid, type : 'email'}, function(data) {
				Ticket.prepareNoteForm(data);
				Ticket.initAutoSave();

				if(Ticket.timetrackingAutoIsOkay() && Ticket.timetrackingAuto.trigger === 'answer') {
					Ticket.timetrackingAutoStart(ticketid);
				} else if ($('#supportTimerList').length > 0) {
					Ticket.timetrackingAutoInitTimersList(ticketid);
				}

				TokenInput.autoSupportTemplate($('#email_template'), function(item) {
					var message = $('#templateTexts_' + item.id).find('div.message').html();
					$("#conv_message").redactor("set", message);
					$("#conv_message").redactor("sync");

					$(this).tokenInput('clear');
				});

				Qtip.init();

			}, 'json');
		}
	},

	save : function(autosave){

		if(autosave == "undefined" || autosave == "N") {

			$('#conv_autoSave').val('N');
			$("#ticketActions").show();
			$("#ticketInfos .summary div").removeClass("active");
		}else {

			$('#conv_autoSave').val('Y');
		}
		$('#conv_draft').val('Y');

		$('#conversationForm').submit();
	},

	editConv : function(ticketID, convID){

		MyFacture.post(	'support_ticket',
			{action : "conversationForm", ticketid : ticketID, type : 'email', convID : convID},
			function(data){
				$("body").scrollTop(0);
				$('#conv-'+convID).hide();
				Ticket.initAutoSave();
				Ticket.prepareNoteForm(data);
				Qtip.init();
			},
			'json');
	},

	editNote : function(ticketID, convID){

		MyFacture.post(	'support_ticket',
			{
				action		: "conversationForm",
				ticketid	: ticketID,
				type		: 'note',
				convID		: convID
			},
			function(data){
				$("body").scrollTop(0);
				$('#conv-'+convID).hide();
				Ticket.prepareNoteForm(data);
			},
			'json');
	},

	deleteConv : function(ticketID, convID){

		var options = {
			type		: "warning",
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Suppression du brouillon"),
			buttons		: [
				{
					text : Loc.g("Annuler"),
					click : function(){
						$(this).dialog("close");
					}
				},
                {
					text : Loc.g("Valider"),
                    click : function(){

                        MyFacture.post(	'support_ticket',
                            {
								action : "deleteConversation",
								ticketid : ticketID,
								convID : convID
							},
                            function(data){
                                $("#conv-"+convID).remove();
                            },
                            'json'
						);

                        $(this).dialog("close");
                    }
                }
            ]
		};

		MyWindow.alert(Loc.g("Valider pour supprimer le brouillon"), options);
	},

	deleteNote : function(ticketID, convID){

		var options = {
			type		: "warning",
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Suppression de la note"),
			buttons		: [
				{
					text : Loc.g("Annuler"),
					click : function(){
						$(this).dialog("close");
					}
				},
                {
					text : Loc.g("Valider"),
                    click : function(){
                        MyFacture.post(
							'support_ticket',
                            {
								action : "deleteConversation",
								ticketid : ticketID,
								convID : convID
							},
                            function(data){
                                $("#conv-"+convID).remove();
                            },
                            'json'
						);

                        $(this).dialog("close");
                    }
                }
            ]
		};

		MyWindow.alert(Loc.g("Valider pour supprimer la note"), options);
	},

	cancel : function(tid){
		$("#ticketActions").show();
		$("#ticketInfos .summary div").removeClass("active");
		$('#timeline #formContainer').empty();
		clearInterval(this.timerAutosave);

		MyFacture.post('support_ticket',
			{
				action : "resetUpdating",
				ticketid : tid
			},
			function(data){
				$('#timelineContent').html(data.timeline);
				Ticket.resetOverviewInfiniteScroll();

				Ticket.callForResize();
			},
			'json'
		);

	},

	assign : function(ticketid, staffid){

		MyFacture.post('support_ticket',
			{
				action : "assignRecord",
				ticketid : ticketid,
				staffid : staffid
			},
			function(data){

				if(data.error != '0'){
					MyWindow.alert(data.errormsg, {type : 'error'});
				}else{
					if ($('#ticketsListing_subEngineContent').length > 0){
						Ticket.unbindTicketListingRow(ticketid);
					} else {
						$('#timelineContent').html(data.timeline);
						Ticket.resetOverviewInfiniteScroll();
						Ticket.callForResize();
						if (Ticket.timetrackingAutoIsOkay()) {
							Ticket.timetrackingAutoSave(ticketid);
						}
					}
				}
			},
			'json');
		$('.b-m-mpanel').hide();
	},

	step : function(ticketid, step){

		MyFacture.post(	'support_ticket',
			{
				action		: "stepRecord",
				ticketid	: ticketid,
				step		: step
			},
			function(data){
				if(data.error != '0'){
					MyWindow.alert(data.errormsg, {type : 'error'});
				}else{
					if ($('#ticketsListing_subEngineContent').length > 0){
						Ticket.unbindTicketListingRow(ticketid);
					} else {
						$('#timelineContent').html(data.timeline);
						Ticket.resetOverviewInfiniteScroll();
						$('h3.ident .tstep').remove();
						$('h3.ident').prepend(data.stepLabel);

						Ticket.callForResize();
					}

					$("#tStepTicket").html($('#conv_step option:selected').html());
					$("#tStepTicket").removeAttr("class");
					$("#tStepTicket").addClass("tstep-"+step +"-bg tstep");

				}
			},
			'json'
		);
		$('.b-m-mpanel').hide();
	},

	toStep : function(ticketid, step) {
		MyFacture.post(	'support_ticket',
			{
				action		: "stepRecord",
				ticketid	: ticketid,
				step		: step
			},
			function(data) {
				if(step === 'closed' && Ticket.timetrackingAutoIsOkay()) {
					Ticket.timetrackingAutoSave(ticketid);
				} else {
					Utils.reload();
				}
			},
			'json'
		);
	},

	unbindTicketListingRow : function(ticketid){

		$("tr#ticket_"+ticketid)
				.removeClass('hasRightClick')
				.addClass('processedTicket');

		$("tr#ticket_" + ticketid + ", tr#ticket_" + ticketid + " td").unbind('contextmenu').bind('contextmenu', function (e) {

			MyWindow.alert(Loc.g("Vous avez déjà traité ce ticket.")+"<br /><br />"+Loc.g("Rechargez le listing si vous souhaitez modifier l'affectation ou le statut du ticket."), {type : 'warning'});
			e.preventDefault();
			return false;

		});

		$("tr#ticket_" + ticketid).find('.groupedActionCheckerContainer').find('input[type=checkbox], label').remove();
	},

	prepareNoteForm : function(data){

		$("#ticketActions").hide();

		$('#timeline #formContainer').empty().append(data.form);

		$('.summaryBtn .fa-circle-o-notch').fadeOut(300, function(){
			$(this).remove();
		});

		$('#timeline #formContainer:hidden').slideDown('fast');

		var options = {
			success: function(data) {

				if(data.timetracking !== undefined) {
					MyFacture.post('timetracking_entries', data.timetracking, function() {
						Ticket.timetrackingAutoInitTimersList(data.timetracking.entry_ttLinkedElementlinked);
					});
				}

				var formIsOk = MyForm.processJson(data, "conversationForm");
				$("#formContainer #preloader").remove();

				if(formIsOk){

					$('#timelineContent').html(data.timeline);
					Ticket.resetOverviewInfiniteScroll();

					// FIX BUG ON OVERVIEW THIRD
					var isOnOverviewThird = $("body").hasClass("page-third") || $("#onOverview").length > 0;

					if (!isOnOverviewThird) {
						Ticket.callForResize();
					}

					if(data.autosave === "N") {

						if (data.step === "closed" && !isOnOverviewThird) {
							Utils.relocate('?_f=support_tickets');
							return false;
						}

						$("#ticketActions").show();
						$("#ticketInfos .summary div").removeClass("active");
						$('#formContainer').slideUp('fast', function(){
							$(this).empty().show();
						});

						if(data.draft === "N") {
							$('#conv_assignTo').val(data.assignedTo);
						}

						$('#conv_step').val(data.step);
						$('h3.ident .tstep').remove();
						$('h3.ident').prepend(data.stepLabel);

						$("#tStepTicket")
								.html($('#conv_step option:selected').html())
								.removeAttr("class")
								.addClass("tstep-"+data.step +"-bg tstep");

						Ticket.checkForPreviews();

					}else {
						$("#autosaving").hide();
						$("#conv_id").val(data.convid);
					}
				}
			},
			beforeSubmit : function(){

				if($("#conv_autoSave").val() === "Y") {
					$("#autosaving").show();
				}
				else {
					var $preloader = $('<div id="preloader" />');
					$preloader.appendTo('#formContainer');
				}
			},
			dataType	: "json",
			data		: {
				action: 'conversationRecord'
			}
		};

		MyForm.prepare("conversationForm", "support_ticket", options, false, false);
		MyFacture.customForm();

		// $(".qq-upload-drop-area").show();

	},

	prepareUpdateThirdForm : function(ticketid){
		var formID = 'updateThirdForm';

		TokenInput.autoContact($('#requester'), 'thirdContact', '', 1,
			function(item){

				if($('#requesterEmail').val() === '' && item.name !== undefined){
					$('#requesterEmail').val(item.email);
					MyFacture.customForm('#upThirdContactEmail');
				}else if($('#requesterEmail').val() === '' && item.name === undefined){
					$('#requesterEmail').val(item.email);
				}else if($('#requesterEmail').val() !== '' && item.email === ''){
					$('#upThirdContactEmail').show();
					MyFacture.customForm('#upThirdContactEmail');
				}

				if(item.thirdid !== undefined && item.thirdname !== undefined){
					$("#thirdid").tokenInput('add', {id : item.thirdid, name: item.thirdname});
					$("#requester").tokenInput('more', 'thirdid_'+item.thirdid);
				}

			},

			function(item){
				$('#requesterEmail').val($('#originalRequesterEmail').val());
				$('#upThirdContactEmail').hide();
			}
		);

		var options = {
			success		: function(data){

				var formIsOk = MyForm.processJson(data, formID);

				if(formIsOk){
					Utils.reload();
				}
			},
			dataType	: "json",
			data		: {
				action		: 'updateThird',
				ticketid	: ticketid
			}
		};

		MyForm.prepare(formID, 'support_ticket', options, false);

	},

	initOverview : function(ticketid) {
		MyTabs.initVertical('ticketOverview');
		MyTabs.initHorizontal('contactSwitch');

		Ticket.prepareUpdateThirdForm(ticketid);

		Ticket.loadTracking();

		Ticket.callForResize();

		$('#timelineContent').unbind().scroll(function(event) {

			var scrollMargin	= 120;
			if(	!Ticket.overviewInfiniteScroll.locked
				&& !Ticket.overviewInfiniteScroll.processing
				&& ($(this).scrollTop() + $(this).innerHeight()) >= ($(this)[0].scrollHeight - scrollMargin)) {

				// if we're at the end of the eventList
				Ticket.overviewInfiniteScroll.processing = true;
				Ticket.injectTimeline(ticketid);
			}

		});

		Ticket.checkForPreviews();

		if($('#supportTimerList').length){

			// timetracking auto
			Ticket.initTimetrackingAuto();

			if(Ticket.timetrackingAutoIsOkay() && Ticket.timetrackingAuto.trigger === 'open') {

				Ticket.timetrackingAutoStart(ticketid);

			} else {

				Ticket.timetrackingAutoInitTimersList(ticketid);

			}

		}

		Qtip.init();

        // Ticket.initHideOrShowConversation();
	},

	// TIMETRACKING
	timetrackingAuto	: {
		plugin		: {
			enabled	: 'N',
			access	: 'restricted'
		},
		activate	: 'N',
		service		: 0,
		current		: 0,
		staffs		: [],
		trigger		: 'open',
		status		: ''
	},

	initTimetrackingAuto : function() {

		var staffsJSON = $('#staffsAutoTimetracking').val();

		Ticket.timetrackingAuto.plugin.enabled	= $('#pluginEnabledTimetracking').val();
		Ticket.timetrackingAuto.plugin.access	= $('#timetrackingPermission').val();

		Ticket.timetrackingAuto.activate		= $('#activateTimetracking').val();
		Ticket.timetrackingAuto.service			= $('#serviceTimetracking').val();
		Ticket.timetrackingAuto.trigger			= $('#triggerTimetracking').val();
		Ticket.timetrackingAuto.current			= $('#currentStaff').val();
		Ticket.timetrackingAuto.staffs			= (staffsJSON !== '' ? JSON.parse(staffsJSON) : []);
		let selectedStatus = $('#stepsList .stepList .fa-check-circle').parent().attr('class');
		Ticket.timetrackingAuto.status			= selectedStatus ? selectedStatus.split('-')[1] : '';

	},

	timetrackingAutoIsOkay : function() {
		return (Ticket.timetrackingAuto.plugin.enabled === 'Y') && (Ticket.timetrackingAuto.plugin.access === 'true')
			&& (Ticket.timetrackingAuto.activate === 'Y') && (Utils.in_array(Ticket.timetrackingAuto.current, Ticket.timetrackingAuto.staffs)
			&& (Ticket.timetrackingAuto.status !== 'closed'));
	},

	timetrackingAutoStart : function(ticketid) {

		MyFacture.post(
			"timetracking_timer",
			{
				action		: "timerAlertList",
				linkedtype	: "ticket",
				linkedid	: ticketid,
				output		: 'json'
			},
			function(data) {
				if(data.timers !== undefined && data.timers.length > 0) {
					// already a timer there :)
					// don't create another timer ! But we need to start it (if he's stopped)
					Ticket.timetrackingAutoInitTimersList(ticketid);

					for(var i in data.timers) {
						var current = data.timers[i];
						if(current.running === 'N') {
							// we need to start it !
							MyFacture.post('timetracking_timer', {
								action	: 'startTimer',
								timerid	: current.id
							}, function() {
								Ticket.timetrackingAutoInitTimersList(ticketid);
							});
						}
					}
				} else {
					// create a timer
					MyFacture.post(
						'timetracking_timer',
						{
							action			: 'recordTimerForm',
							timer_name		: $('#overview .name').html() + ' - AutoTimetracking',
							timer_linkedtype: 'ticket',
							timer_linkedid	: ticketid
						},
						function() {
							Ticket.timetrackingAutoInitTimersList(ticketid);
						},
						'json'
					);
				}
			},
			'json'
		);
	},


	timetrackingAutoSave : function(ticketid) {
		MyFacture.post(
			'timetracking_timer',
			{
				'action'		: 'stopAndSaveTimer',
				'linkedtype'	: 'ticket',
				'linkedid'		: ticketid
			},
			function(data) {
				if(data.timetracking !== undefined && data.timetracking.length > 0) {
					for(var i in data.timetracking) {
						var current = data.timetracking[i];
						MyFacture.post('timetracking_entries', current, function() {
							Ticket.timetrackingAutoInitTimersList(ticketid, false);
							Utils.reload();
						});
					}
				} else {
					Utils.reload();
				}
			},
			'json'
		);
	},

	timetrackingAutoInitTimersList : function(ticketid, async) {

		var async	= async === undefined ? true : async;

		var url		=	location.protocol + '//' + location.hostname + '/?_f=timetracking_timer';
		var data	= {
			action		: "timerAlertList",
			linkedtype	: "ticket",
			linkedid	: ticketid
		};

		$("#supportTimerList").hide();

		$.ajax({
			type		: 'POST',
			url			: url,
			data		: data,
			dataType	: 'json',
			async		: async,
			success		: function(data) {

				$("#supportTimerList").html(data.htmlContent);

				var timers		= $('#supportTimerList .oneTimer .timerTimer');
				var nbTimers	= timers.length;

				$.each(timers, function () {

					var me = $(this);
					if (me.attr('running') === "Y") {
						TimetrackingEntryTimer.startTimer(me.attr('timerid'), 'Y');
					}

					me.closest('li').find('.startAndStop').off('click').on('click', function () {
						if (TimetrackingEntryTimer.timers[me.attr('timerid')] !== undefined) {
							TimetrackingEntryTimer.stopTimer(me.attr('timerid'), 'N');
						} else {
							TimetrackingEntryTimer.startTimer(me.attr('timerid'), 'N');
						}
					});

					Ticket.timetrackingAutoInitUnload(ticketid);

				});

				// HOTFIX Chrome bug visibility
				setTimeout(function() {
					$("#supportTimerList").show();
				}, 300);

				if(nbTimers > 0) {

					$('#supportTimerList #timersLists')
							.find('.acenter.mb5')
							.remove();
				} else {
					$('#supportTimerList #timersLists').off('click').on('click', 'a.btn', function() {
						TimetrackingEntryTimer.createTimer('ticket', ticketid);
					});
				}
			}
		});
	},
	timetrackingAutoInitUnload : function(ticketid) {
		$(window).on('unload', function(event) {

			var url		=	location.protocol + '//' + location.hostname + '/?_f=timetracking_timer';
			var data	=	{
				action		: "stopTimerRelatedTo",
				linkedtype	: "ticket",
				linkedid	: ticketid
			};

			$.ajax({
				type	: 'POST',
				url		: url,
				data	: data,
				async	: false
			});
		});
	},

	loadTimetracking : function(ticketid) {

		MyFacture.post('timetracking_entries',
			{
				action		: "viewLinkedTimetracking",
				linkedid	: ticketid,
				linkedtype	: 'ticket',
				output		: 'json'
			},
			function(data) {
				$('#content_timetracking').html(data.list);
                $('#content_timetracking').find('.timetrackingList .ttentry').each(function(){
                    const note = $(this).find('.ttNote')[0];
                    if (note.clientHeight < (note.scrollHeight - 1)) {
                        $(this).find('.ttReadMore').show();
                    }
                    $(this).find('ul').addClass('withchip');
                });
			},
			'json'
		);
	},

	refreshAgenda : function(startTime, endTime, days, view) {
		if($('#support-fullcalendar table').length == 0){
			MyFacture.customForm();
			Agenda.initCalendar(startTime, endTime, days, view);
		}
	},

	overviewInfiniteScroll : {
		locked		: false,	// to lock AJAX loading
		processing	: false,	// to lock AJAX loading
		page		: 1			// cause we load page 0 at the load of the dashboard
	},

	injectTimeline : function(ticketid) {
		MyFacture.cleanQueue();
		MyFacture.post( 'support_ticket', {
			action	: "loadTimeline",
			tckid	: ticketid,
			page	: Ticket.overviewInfiniteScroll.page
		}, function(data) {

			$('#timelineContent').append(data.timeline);

			Ticket.overviewInfiniteScroll.processing	= false;
			Ticket.overviewInfiniteScroll.page			= data.page;

			if(data.page == '-1') {
				Ticket.overviewInfiniteScroll.locked	= true;
			}

			Ticket.callForResize();

			Ticket.checkForPreviews();
		}, 'json', true);

		Ticket.checkForPreviews();

	},

	resetOverviewInfiniteScroll : function() {
		Ticket.overviewInfiniteScroll.locked		= false;
		Ticket.overviewInfiniteScroll.processing	= false;
		Ticket.overviewInfiniteScroll.page			= 1;
	},

	showQuote : function(elem) {
		elem.next("div.hiddenQuote").toggle();
	},

	bindContactInput : function(item, idelt){
		var more = item.id.replace('corporation_', 'thirdid_');
		$("#"+idelt).tokenInput('more', more);
	},

	bindContactInputTicketByThird : function(more, elemid){
		$("#"+elemid).tokenInput('more', more);
	},

	unbindContactInput : function(idelt){
		$("#"+idelt).tokenInput('more', '');
	},

	showAlerts : function(alertType){

		$('.ticketsalert:not(.tickets'+alertType+')').hide();
		$('.tickets'+alertType).show();

		$('.headnotif-detail > div > .btn'+alertType)
			.removeClass('btn-default')
			.addClass('btn-primary');

		$('.headnotif-detail > div  > .btn:not(.btn'+alertType+')')
			.removeClass('btn-primary')
			.addClass('btn-default');

	},

	togglefields : function(field) {

		if($("#toggle-btn-"+field).hasClass("activ")) {

			$("#toggle-btn-"+field).removeClass("activ");
			$("#block_"+field).hide();
		}else {

			$("#toggle-btn-"+field).addClass("activ");
			$("#block_"+field).show();
		}
	},

	linkTo : function(tid) {

		var options = {
			title	: Loc.g("Lier un document au ticket"),
			buttons	: [
				{
					text : Loc.g("Annuler"),
					click	: function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Enregistrer"),
					click	: function(){$("#ticketLink").submit();
					}
				}
			],
			callback	: function(){
				Ticket.prepareLinkForm();
			}
		};

		MyWindow.load("support_ticket", {action:"linkForm", tid : tid}, options);

	},

	prepareLinkForm: function(){

		var formId	= "ticketLink";
		var options = {
			data	: {
				action:'linkRecord'
			},
			success	: function(data){
				Ticket.recordLinkCallback(data);
			},
			dataType:"json"
		};

		MyForm.prepare(formId, "support_ticket", options, true);
		MyFacture.initEvent("#ticketLink");

		$('.doctypeLinked').change(function(){
			var show = $(this).val();
			$('.autocompletedoc').hide();
			$('#autocomplete_'+show).show();
		});
	},

	recordLinkCallback: function(data){
		if(data.status === "error"){
            MyWindow.close();
        } else {
			Utils.reload();
		}
	},

	showDocLinked : function() {

		$('#docLinked').toggle(300);
		$("#btn-showLinkedDoc").hasClass("active") ? $("#btn-showLinkedDoc").removeClass("active") : $("#btn-showLinkedDoc").addClass("active");

	},

	alertNoMail : function(callback) {

		if(!$("#conv_sendAlertCustomer").is(':checked') && callback !== undefined){
			$('#conversationForm').submit();
		}else {
			var options = {
				type	:'warning',
				buttons	: [
					{
						text	: Loc.g("Ok"),
						click	: function(){
							$("#updateEmailForm ul.token-input-list").trigger("click");
							$(this).dialog("close");
						}
					}
				]
			};

			MyWindow.alert(Loc.g('Pour répondre au client, veuillez saisir une adresse email de réponse valide dans le formulaire prévu à cet effet.'), options);
		}
	},

	showTimetracking : function(ticketid) {

		var options = {
			width	: 600,
			title	: Loc.g("Liste des entrées de timetracking du ticket"),
			buttons	: [
				{
					text : Loc.g("Fermer"),
					click	: function(){
						$(this).dialog("close");
					}
				}
			]
		};

		MyWindow.load("support_ticket", {action:"timetrackingList", tid : ticketid}, options);
	},

	loadTracking : function() {

		$.each($('[trakingTip]'), function(k,v){

			var me = $(v);
			me.qtip({
				style : {
					classes : 'custom-qtip',
					def		: false
				},
				position: {
					viewport: true,
					my : 'top center',
					at : 'bottom center'
				},
				show : {
					event : 'mouseover'
				},
				hide : {
					event: 'mouseout',
				},
				content: me.find('.qtipAnswer-content')
			});
		});
	},

	initAutoSave : function() {
		this.timerAutosave = setInterval("Ticket.autoSave()", 10000);
	},

	autoSave : function() {

		if(this.contentReply !== $.trim($("#conv_message").val()) ) {

			this.contentReply = $.trim($("#conv_message").val());
			Ticket.save('Y');
		}
	},

	send : function(recipients) {
		clearInterval(this.timerAutosave);
		$('#conv_autoSave').val('N');
		$('#conv_draft').val('N');
		$('#conv_recipients').val(recipients);

		$('#conversationForm').submit();
	},

	displayRecipList : function() {

		$("#chooseRecipiensList").slideToggle(200);
	},

	updateSubject : function(ticketid) {
		var formId = "updateSubjectForm";
		var options = {
			title	: Loc.g('Changer l‘objet du ticket'),
			buttons	:
				[
					{
						text	: Loc.g("Annuler"),
						click	: function () {
							$(this).dialog("close");
						}
					},
                    {
                        text	: Loc.g("Enregistrer"),
                        click	: function () {
                            $("#"+formId).submit();
                        }
                    }
                ],
			width		: 500,
			callback	: function () {
				var options = {
					success		: function ( data ) {
						var formIsOk = MyForm.processJson(data, formId);
						if(formIsOk){
							Utils.reload();
						}
					},
					dataType	: "json",
					data		: {
						action		: "updateSubject",
						ticketid	: ticketid
					}
				};

				MyForm.prepare(formId, "support_ticket", options, true);
				MyFacture.customForm();
			}
		};

		MyWindow.load("support_ticket", {action:"updateSubjectForm", ticketid: ticketid}, options);

	},


	loadConversation : function(ticketID){
		var options = {
			action		: 'tabOverview',
			ticketid	: ticketID
		};

		$('.ticket-row').removeClass('current');
		$('#ticket_'+ticketID).addClass('current');


		MyFacture.post('support_ticket', options, function(data){
			$('#ticketTabOverview').html(data.overview);
			$('#ticketsSideListing').height($('#support_content').height());
			MyFacture.customForm('#ticketTabOverview');

			Ticket.callForResize();
		}, 'json');
	},

	getListing: function(forFirstTime) {

		var forFirstTime	= forFirstTime === undefined ? false : forFirstTime;
		var $ticketsListing = $('#ticketsSideListing');
		var moreBtn			= $ticketsListing.find('.moreBtn a');

		if (!moreBtn.hasClass('stop')) {
			// Type specifies which EventList to load : dashboard, third, invoice, estimate, creditnote...
			var params		= new Object;

            params.page = parseInt($ticketsListing.find('ul').attr('page'), 10) + 1;
			params.thirdid	= $ticketsListing.find('ul').attr('thirdid');
			params.action	= 'loadTickets';

			moreBtn.addClass('stop');

			MyFacture.beLoading(moreBtn);

			MyFacture.post(
				'support_tickets',
				params,
				function(data) {
					Ticket.getListingCallback(data, forFirstTime);
				},
				'json'
			);
		}
	},

	getListingCallback : function(data, clean){
		var $ticketsListing = $('#ticketsSideListing');
		var clean			= clean === undefined ? false : clean;

		if(clean){
			$ticketsListing.find('ul').empty();
		}

		if (data) {
            $ticketsListing.find('ul').append(data.ticketsListing);
            var currentPage = parseInt($ticketsListing.find('ul').attr('page'), 10);
            if(!(clean && currentPage == 1)){
                currentPage++;
                $ticketsListing.find('ul').attr('page', currentPage);
            }

			if (data.newPageNB == '0') {
				$ticketsListing.find('.moreBtn').hide();
			}

			$ticketsListing.find('.moreBtn a').removeClass('stop');
			MyFacture.beLoading($ticketsListing.find('.moreBtn a'));
		}

		$ticketsListing.find('.nano').nanoScroller({preventPageScrolling: true});

		if(clean){
			$ticketsListing.find('.nano').debounce("scrollend", function(e){
				var trigg = $ticketsListing.find('.moreBtn a');
				if (!trigg.hasClass('stop') && trigg.is(':visible')){
					trigg.trigger('click');
					$ticketsListing.find('.nano').nanoScroller({preventPageScrolling: true});
				}
			});
		}
	},

	hideOrShowConversation: function(el) {
		var message 		= $(el).parents(".conv-message");
		var messageContent 	= message.find(".message");

		if (messageContent.height() >= 200 ) {
			messageContent.toggleClass("js-reduce");
			messageContent.hasClass("js-reduce") ? $(el).html(Loc.g('Agrandir') + ' [ + ]') : $(el).html(Loc.g('Réduire') + ' [ - ]');
		}
	},

	hideOrShowAllConversation: function(hide) {
		var contains = hide ? '-' : '+';

		$(".actionReduceOrExpandConversation:contains('" + contains + "')").each(function(i, value) {
			$(value).trigger('click');
		});
	},

	callForResize: function() {
		iFrameResize({
			heightCalculationMethod	: 'max'
		},".ticket-conversation");
	},

	toggleStatus : function(status){

		if($('#'+status).is(':visible')){
			$('#'+status).hide();
			$('#'+status+'_toggler i').removeClass('fa-caret-up').addClass('fa-caret-down');
		}else{
			$('#'+status).show();
			$('#'+status+'_toggler i').addClass('fa-caret-up').removeClass('fa-caret-down');
		}
	},

	checkForPreviews : function() {
		var pjs = $('#timelineContent .conv-pj a');

		pjs.each(function(i, el) {
			var node 			= $(el);
			var filename		= node.text();
			var convMessage		= node.closest('.conv-entry').find('.conv-message');
			var idConvMessage	= convMessage.attr('id');

			if(	filename.endsWith('.png') ||
				filename.endsWith('.jpg') ||
				filename.endsWith('.gif') ||
				filename.endsWith('.jpeg') ||
				filename.endsWith('.pdf')) {

				node.on('click', function (event) {
					var currentPreview	= $('#'+idConvMessage).data('currentPreview');

					var hasPreviewAndSameFile = UtilsWindow.waitExists(idConvMessage) && currentPreview === filename;
					var hasPreviewButNewFile = UtilsWindow.waitExists(idConvMessage) && currentPreview !== filename;
					var hasNoPreviewOrNewFile = !UtilsWindow.waitExists(idConvMessage) || (hasPreviewButNewFile);

					// we already have the image so we fade it :)
					if (hasPreviewAndSameFile) {
						Ticket.previewClose(idConvMessage);
					}
					// another image is already there, let's remove it first
					if (hasPreviewButNewFile) {
						Ticket.previewClose(idConvMessage);
					}
					// nothing showed, we show the image !
					if (hasNoPreviewOrNewFile) {
						Ticket.previewOpen(idConvMessage, node, filename);
					}

					if (hasPreviewAndSameFile || hasPreviewButNewFile || hasNoPreviewOrNewFile) {
						// cut click
						event.preventDefault();
						return false;
					}
				});
			}

		});

	},

	previewClose : function(idConvMessage) {

		UtilsWindow.awake(idConvMessage);

		$('#'+idConvMessage).data('currentPreview', null);

		var oldHeight = $('#'+idConvMessage).data('oldHeight');

		if(oldHeight > 0) {
			$('#'+idConvMessage).css('height', oldHeight);
		}
	},

	previewOpen : function(idConvMessage, node, filename) {

		if (!$('#'+idConvMessage).data('oldHeight')) {
			$('#'+idConvMessage).data('oldHeight', $('#'+idConvMessage).height());
		}

		var waitDiv = UtilsWindow.getWaitDiv(idConvMessage);

		UtilsWindow.wait(idConvMessage);
		$('#'+idConvMessage).data('currentPreview', filename);

		$('#'+waitDiv).on('click', function() {
			Ticket.previewClose(idConvMessage);
		});

		if(filename.endsWith('.pdf')) {
			$('#'+waitDiv).append('<embed src="' + node.attr('href') + '&display=Y" style="display: block; margin: 20px auto; width: 500px; height: 300px;"/>');

			//var waitHeight = $('#' +waitDiv+ ' embed').height() + 40;
			var waitHeight = 340;

			$('#'+idConvMessage).css('height', waitHeight);
			$('#'+waitDiv).css('height', waitHeight+20);
		} else {
			$('#'+waitDiv).append('<img src="' + node.attr('href') + '&display=Y' + '" style="display: block; margin: 20px auto;"/>');

			$('#' +waitDiv+ ' img').on('load', function() {
				// check if image is too large
				var previewWidth	= $('#' +waitDiv).width();
				var imageWidth 		= $('#' +waitDiv+ ' img').width();
				if(previewWidth < imageWidth) {
					$('#' +waitDiv+ ' img').css('width', '85%');
				}

				// then check for image height
				var waitHeight = $('#' +waitDiv+ ' img').height() + 40;
				$('#'+idConvMessage).css('height', waitHeight).css('overflow', 'hidden');
				$('#'+waitDiv).css('height', waitHeight+20);
			});
		}
		$('#'+waitDiv).append('<a href="' +node.attr('href')+ '" class="fa fa-download primary-50" style="font-size: 20; opacity: 0.8; position: absolute; top: 20px; right: 20px;"></a>');
	},

	modifyActionCreateTicket : function(){

		var actionSelect = $('select[name=ticket_action]').val();

		if(actionSelect === "email"){

			$('#labelCopyMail').show();
			$('#email-template').show();

			if($('#linkCciVisible').is(':hidden') && $('#linkCcVisible').is(':hidden')){
				$('#inputCc').show();
				$('#inputCci').show();
			} else if($('#linkCcVisible').is(':hidden')){
				$('#inputCc').show();
			} else if($('#linkCciVisible').is(':hidden')){
				$('#inputCci').show();
			}

		} else {

			$('#email-template').hide();
			$('#labelCopyMail').hide();
			$('#inputCc').hide();
			$('#inputCci').hide();

		}
		this.modifyPlacementButtonUpload();
	},

	modifyPlacementButtonUpload: function() {
		var actionSelect = $('select[name=ticket_action]').val();
                var sizeComment = 0;
                if($('#email-template .comment').is(':visible')){
                    sizeComment = 18;
                }
                if(actionSelect === "email"){
                    if($('#linkCciVisible').is(':hidden') && $('#linkCcVisible').is(':hidden')){
                        $('#divButtonUpload').css("top", 704 + sizeComment);
                    } else if($('#linkCcVisible').is(':hidden')){
                        $('#divButtonUpload').css("top", 676 + sizeComment);
                    } else if($('#linkCciVisible').is(':hidden')){
                        $('#divButtonUpload').css("top", 676 + sizeComment);
                    } else {
                        $('#divButtonUpload').css("top", 648 + sizeComment);
                    }
                } else {
                    $('#divButtonUpload').css("top", 582);
                }
        },

	injectTemplate : function(){
		var idtpl		= $('select[name=email_template]').val();
		var template	= $('#templateTexts_'+idtpl);

		$('[e_autoattachement]').length > 0 && $('[e_autoattachement]').data('tokenInputObject').clear();

		if(template.length > 0){
			var tpl = {
				subject		: template.find('input.subject').val(),
				message		: template.find('div.message').html(),
				attachments : template.attr('attachment_json') !== undefined ? JSON.parse(template.attr('attachment_json')) : []
			};

			// SUBJECT
			var subject = $("#ticket_subject");

			if(subject.data('redactor') !== undefined){
				subject.redactor("set", tpl.subject);
				subject.redactor("sync");
			} else {
				subject.val(tpl.subject);
			}

			// MESSAGE
			var message = $("#ticket_message");

			if(message.data('redactor') !== undefined){
				message.redactor("set", tpl.message);
				message.redactor("sync");
			}

			// ATTACHMENTS
			if(tpl.attachments.length > 0){
				$.each(tpl.attachments, function(i, item){
					$('[e_autoattachement]').data('tokenInputObject').add(item);
				});
			}

			$('#email-template .comment').css('display', 'block');
		}else{
			$('#email-template .comment').hide();
		}
                this.modifyPlacementButtonUpload();
	},

	linkTicketToDoc : function(linkedtype, linkedid){

		var options = {
			dialogClass : "white",
			title	: Loc.g("Lier un ticket de support"),
			buttons	: [
				{
					text	: Loc.g("Annuler"),
					click	: function () {
						$(this).dialog("close");
					}
				},
				{
					text	: Loc.g("Lier"),
					click	: function(){
						$("#ticketLinkToDocForm").submit();
					}
                }
			],
			width	: 800,
			callback: function(){
				Qtip.init();
				Ticket.prepareLinkTicketForm();
			}
		};

		var fileOpt = {
			action		:"linkTicketToDocForm",
			linkedtype	: linkedtype,
			linkedid	: linkedid
		};
		MyWindow.load("support_ticket", fileOpt, options);

	},

	prepareLinkTicketForm: function(){
		var formId = "ticketLinkToDocForm";
		var options = {
			success	: function(data){
				Ticket.recordLinkTicketCallback(data);
			},
			data	: {
				action : 'linkTicketRecord'
			},
			dataType : "json"
		};
		MyForm.prepare(formId, "support_ticket", options, true);
		MyFacture.initEvent("#ticketLinkToDocForm");
	},

	recordLinkTicketCallback: function(data){
        MyWindow.close();
	},

	unlinkTicketToDoc : function(docLinkedElemId){
		var options = {
			type        : "warning",
			resizable   : false,
			noclose     : true,
			title       : Loc.g("Confirmation"),
			buttons     : [
                {
                    text : Loc.g("Annuler"),
					click : function(){
						$(this).dialog("close");
					}
                },
                {
					text : Loc.g("Délier"),
					click : function(){
						Ticket.unlinkTicketToDocRecord(docLinkedElemId);
						$(this).dialog("close");
					}
				}
			]
		};

		MyWindow.alert(Loc.g('Êtes-vous sûr de vouloir délier le ticket de support du document ?'), options);
	},

	unlinkTicketToDocRecord : function(docLinkedElemId){

		MyFacture.post("support_ticket",
			{
				action          : "unlinkTicketToDoc",
				docLinkedElemId : docLinkedElemId
			},
			function(data){
				if(data.status === 'ok'){
					$('.ticketLinkedToDoc #'+docLinkedElemId+'').remove();
				}
			},
			"json"
		);

	},

	loadLinkedTab : function(doctype, ticketid){

		MyFacture.post('support_ticket',
			{
				action      : 'loadLinkedTab',
				doctype     : doctype,
				ticketid    : ticketid
			},
			function (data) {
				if(data.hasDocLinked === 'Y'){
					$('#content_docLinkeds .contentlist').html(data.doclinkedList);
					$('#content_docLinkeds').show();
				}
			},
			'json'
		);
	},

    readmore: function(e) {
        const isReadMore = $(e).hasClass('ttReadMore');
        $(e).closest('.ttentry').toggleClass('readmore');

        if(isReadMore) {
            $(e).parent().find('.ttReadLess').show();
            $(e).parent().find('.ttReadMore').hide();
        } else {
            $(e).parent().find('.ttReadMore').show();
            $(e).parent().find('.ttReadLess').hide();
        }
    }
};
